"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_TPA_PARAMS = exports.DEFAULT_LOCALE = exports.TPAEditMode = exports.TPAViewMode = exports.TPADeviceType = void 0;
var TPAViewMode;
(function (TPAViewMode) {
    TPAViewMode["STANDALONE"] = "standalone";
    TPAViewMode["SITE"] = "site";
    TPAViewMode["EDITOR"] = "editor";
    TPAViewMode["EDITOR_PREVIEW"] = "preview";
    TPAViewMode["DEV_EDITOR"] = "dev-editor";
})(TPAViewMode || (TPAViewMode = {}));
exports.TPAViewMode = TPAViewMode;
var TPAEditMode;
(function (TPAEditMode) {
    TPAEditMode["EDITOR"] = "editor";
    TPAEditMode["PREVIEW"] = "preview";
})(TPAEditMode || (TPAEditMode = {}));
exports.TPAEditMode = TPAEditMode;
var TPADeviceType;
(function (TPADeviceType) {
    TPADeviceType["MOBILE"] = "mobile";
    TPADeviceType["DESKTOP"] = "desktop";
})(TPADeviceType || (TPADeviceType = {}));
exports.TPADeviceType = TPADeviceType;
var DEFAULT_LOCALE = 'en';
exports.DEFAULT_LOCALE = DEFAULT_LOCALE;
var DEFAULT_TPA_PARAMS = {
    locale: DEFAULT_LOCALE,
    deviceType: TPADeviceType.DESKTOP,
    viewMode: TPAViewMode.STANDALONE,
    commonConfig: '{}',
};
exports.DEFAULT_TPA_PARAMS = DEFAULT_TPA_PARAMS;
//# sourceMappingURL=constants.js.map